export default "__VITE_PUBLIC_ASSET__5557e53a__"